import React from 'react';

const PeerCardHeading = ({ heading, url }) => {
  return heading && url ? (
    <h2 className={`peer-cards__heading`}>
      <a href={url} className={`js-card-link peer-cards__heading-link`}>
        <span dangerouslySetInnerHTML={{ __html: heading }}></span>
      </a>
    </h2>
  ) : null;
};

export default PeerCardHeading;
